module.exports = __webpack_public_path__ + "assets/img/IntelligentAudit.028fd4a7.png";